import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpBody, IHttpClient } from 'utils/http/httpClient.model';

import type { DlpOrderRequest, DlpSecondaryOrderResponse } from './model';

export interface DlpOrderApi {
  placeOrder(request: DlpOrderRequest): Observable<DlpSecondaryOrderResponse>;
}
export function dlpOrderApiConnector(httpClient: IHttpClient): DlpOrderApi {
  return {
    placeOrder: req => {
      return httpClient
        .postJSON<DlpSecondaryOrderResponse>({
          url: 'api/v1/secondary-market/dlp/products/execute',
          body: req as IHttpBody,
          timeOut: 10_000,
          tryParseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
